import React, { useState } from "react";
import {
    CircularProgress,
    Dialog,
    InputAdornment,
    TextField,
    Typography,
} from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import PostData from "../../services/PostData";
import ConfirmUploadRecord from "./ConfirmUploadRecord";
import ConfirmEbayRecord from "./ConfirmEbayRecord";
import { catalogSearchFieldSx } from "../Products/catalogGridStyles.js";
import SnackbarEx from "../Helpers/SnackbarEx";
import "./uploadProducts.css";

export default function AirtableRecord({ channel }) {
    const [searchSku, setSearchSku] = useState("");
    const [loadSubmit, setLoadSubmit] = useState(false);
    const [openWalmartRecordData, setOpenWalmartRecordData] = useState(false);
    const [openEbayRecordData, setOpenEbayRecordData] = useState(false);
    const [snack, setSnack] = useState({ color: "", message: "", open: false });

    const submitSearchSku = async (event) => {
        event.preventDefault();
        const sku = String(searchSku || "").trim();
        if (!sku) {
            setSnack({ color: "warning", message: "Enter a SKU to search.", open: true });
            return;
        }

        setLoadSubmit(true);
        const { success, data } = await PostData(
            { sku },
            `broylesllc/get-${channel}-record`,
            null
        );
        setLoadSubmit(false);
        if (success) {
            const dataAndSku = { ...data, sku };
            if (channel === "walmart") setOpenWalmartRecordData(dataAndSku);
            else setOpenEbayRecordData(dataAndSku);
            return;
        }
        setSnack({
            color: "error",
            message: "SKU not found in Products.",
            open: true,
        });
    };

    const closeAndReset = (val) => {
        setOpenWalmartRecordData(false);
        setOpenEbayRecordData(false);
        if (val === "success") setSearchSku("");
    };

    const channelLabel = channel === "walmart" ? "Walmart" : "eBay";

    return (
        <>
            <form onSubmit={submitSearchSku} className="upload-search-hero">
                <span
                    className={`upload-channel-pill ${channel === "walmart" ? "is-walmart" : "is-ebay"
                        }`}
                >
                    {channelLabel}
                </span>
                <label className="upload-search-hero-label" htmlFor="sku-search">
                    Search Product SKU
                </label>
                <TextField
                    id="sku-search"
                    size="small"
                    disabled={loadSubmit}
                    name="sku"
                    value={searchSku}
                    placeholder="Internal SKU ID"
                    onChange={(e) => setSearchSku(e.target.value)}
                    sx={{ ...catalogSearchFieldSx, width: "100%" }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchOutlinedIcon sx={{ color: "#9aa3ad", fontSize: 18 }} />
                            </InputAdornment>
                        ),
                        endAdornment: loadSubmit ? (
                            <InputAdornment position="end">
                                <CircularProgress size={18} sx={{ color: "#0d9488" }} />
                            </InputAdornment>
                        ) : null,
                    }}
                />
                <Typography className="upload-search-hero-hint" component="p">
                    Finds product, then opens a confirm step before
                    uploading to {channelLabel}.
                </Typography>
            </form>

            <Dialog
                maxWidth="sm"
                fullWidth
                open={Boolean(openWalmartRecordData)}
                onClose={() => setOpenWalmartRecordData(false)}
                PaperProps={{ sx: { borderRadius: "14px" } }}
            >
                <ConfirmUploadRecord
                    recordData={openWalmartRecordData}
                    closeDialog={(v) => closeAndReset(v)}
                />
            </Dialog>
            <Dialog
                maxWidth="sm"
                fullWidth
                open={Boolean(openEbayRecordData)}
                onClose={() => setOpenEbayRecordData(false)}
                PaperProps={{ sx: { borderRadius: "14px" } }}
            >
                <ConfirmEbayRecord
                    recordData={openEbayRecordData}
                    closeDialog={(v) => closeAndReset(v)}
                />
            </Dialog>

            {snack.open && (
                <SnackbarEx
                    color={snack.color}
                    message={snack.message}
                    open={snack.open}
                    close={() => setSnack({ color: "", message: "", open: false })}
                />
            )}
        </>
    );
}
